import React from 'react';
import { MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { ActionLink } from './Buttons';
import { TornEdge } from './TornEdge';
import { Reveal } from './Reveal';
import { contact } from '../data/contact';
interface FinalCTAProps {
  freeInitialConsultation: boolean;
}
export function FinalCTA({
  freeInitialConsultation
}: FinalCTAProps) {
  return <section aria-labelledby="cta-title" className="relative overflow-hidden bg-plum py-20 sm:py-28" data-id="element-33" data-mp="87js0fnfcgiv">
      <TornEdge colorClassName="bg-plum" data-id="element-34" data-mp="h6569ylv59du" />
      <div aria-hidden="true" className="smoke-veil pointer-events-none absolute inset-0 opacity-40" data-id="element-35" data-mp="h52i3yfxdl1m" />
      <div className="relative mx-auto w-full max-w-3xl px-5 text-center sm:px-8" data-id="element-36" data-mp="vwuk78qpl2le">
        <Reveal data-id="element-37" data-mp="qw6uqri4otta">
          <span className="font-folio text-[0.62rem] uppercase tracking-[0.3em] text-gold/80" data-id="element-38" data-mp="qxrpah4g0cr5">
            Sección VII · Solicitud de consulta
          </span>
          <h2 id="cta-title" className="mt-6 font-display text-[1.65rem] font-light uppercase leading-tight tracking-[0.05em] text-paper sm:text-4xl" data-id="element-39" data-mp="zxeg68zjq05y">
            ¿Deseas conocer nuestras prácticas y servicios?
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-[0.98rem] leading-relaxed text-body sm:text-lg" data-id="element-40" data-mp="2m2ud5e94ydb2">
            Comunícate con nuestro equipo para solicitar una consulta.
          </p>
        </Reveal>

        <Reveal delay={0.1} className="mt-11 flex flex-col items-center gap-3.5 sm:flex-row sm:justify-center" data-id="element-41" data-mp="2v3sfzt7u8es2">
          <ActionLink href={contact.whatsappHref} variant="gold" target="_blank" rel="noreferrer" className="w-full sm:w-auto" data-id="element-42" data-mp="301aqho1i7226">
            <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-43" data-mp="39r3spyfra4tr" />
            Hablar con un Chamán
          </ActionLink>
          <ActionLink href={contact.phoneHref} variant="outline" className="w-full sm:w-auto" aria-label={`Llamar ahora al ${contact.phone}`} data-id="element-44" data-mp="3epf1s6y88bax">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-45" data-mp="1jm8ye86x6n22" />
            Llamar Ahora
          </ActionLink>
        </Reveal>

        {freeInitialConsultation ? <Reveal delay={0.16} className="mt-9" data-id="element-46" data-mp="1shgiv7argf17">
            <p className="font-folio text-[0.72rem] uppercase tracking-[0.22em] text-gold" data-id="element-47" data-mp="1npyjgnodymic">
              Consulta inicial sin costo.
            </p>
            <p className="mx-auto mt-3 max-w-xl text-xs leading-relaxed text-body/75 sm:text-[0.8rem]" data-id="element-48" data-mp="22djio6i541kz">
              Los servicios adicionales y materiales, cuando correspondan, tienen
              un costo que se informa antes de cualquier pago.
            </p>
          </Reveal> : null}
      </div>
    </section>;
}